import { Box } from "@chakra-ui/react"

export const ContentAccordionLeft = ({ children }) => {
  return (
    <Box flex="0 1 50%" py="10" px="12">
      {children}
    </Box>
  )
}
